import React from 'react';
import DataGrid from '../../../../../table/DataGrid';
import { Chip, Typography } from '@mui/material';
import { getValueElement, printKey } from '../../TableCompare/utils';

const ManyCreated = ({ detail }) => {
  return (
    <div className='relative mt-4 h-screen-1/5 overflow-auto'>
      <DataGrid
        id='table-compare-import'
        showSetting={false}
        rows={detail?.data?.map((row, index) => ({
          ...row,
          index: index + 1,
          _id: row._id,
          status: (
            <Chip
              label={row.error ? 'Error' : 'Created'}
              color={row.error ? 'error' : 'success'}
              size='small'
            />
          ),
          fields: row.error
            ? Object.keys(row.errors || {}).map((key, er) => (
                <div key={`item_${row._id}_error_${er}`}>
                  <Typography
                    variant='inherit'
                    component={'span'}
                    color='primary'
                    className='font-bold text-2xs uppercase pr-2'
                  >
                    {printKey(key)}:
                  </Typography>
                  <Typography component={'span'} variant='inherit' className='text-sm'>
                    {row?.errors?.[key]}
                  </Typography>
                </div>
              ))
            : Object.keys(row)
                .filter((key) => !['error', 'errors', 'message'].includes(key))
                .map((key, i) => (
                  <div key={`item_${row._id}_error_${i}`}>
                    <Typography
                      variant='inherit'
                      component={'span'}
                      color='primary'
                      className='font-bold text-2xs uppercase pr-2'
                    >
                      {printKey(key)}:
                    </Typography>
                    <Typography component={'span'} variant='inherit' className='text-sm'>
                      {getValueElement(row[key], key)}
                    </Typography>
                  </div>
                ))
        }))}
        rowsPerPage={detail?.data?.length || 0}
        columns={[
          { label: '#', key: 'index', align: 'center', width: 20, show: true, hide: false },
          { label: 'name', key: 'name', width: 50, show: true, hide: false },
          { label: 'status', key: 'status', show: true, hide: false },
          { label: 'fields', key: 'fields', show: true, hide: false }
        ]}
        labelNoRows="You don't have any changes yet"
      />
    </div>
  );
};

export default ManyCreated;
